<template>
  <div
    :key="variantRerender ? variant.id : product.id"
    class="wishlist-button"
    js-product-form="wishlist"
    :data-product-handle="product.handle"
    :data-variant-id="variant?.id"
    @click="handleWishlistClicked"
  >
    <button
      class="wishlist-button__btn"
      type="button"
    >
      <icon-wishlist />
    </button>
  </div>
</template>

<script>

/**
 * Vue: Wishlist button (wishlist-button)
 * -----------------------------------------------------------------------------
 * Wishlist button on PDPs.
 *
 */

import IconWishlist from '~icons/general/wishlist.svg'

export default {
  name: 'WishlistButton',

  components: {
    IconWishlist,
  },

  inject: {
    context: {
      default: 'PDP',
    },
  },

  props: {
    product: {
      type: [Boolean, Object],
      default: false,
      required: true,
    },
    variant: {
      type: [Boolean, Object],
      default: false,
      required: true,
    },
    variantRerender: {
      type: Boolean,
      default: true,
    },
  },

  methods: {

    /**
     * Track wishlist event
     */
    handleWishlistClicked() {
      if (this.context === 'drawer') {
        track({ event: 'quick_add_wishlist_clicked' })
      }
    },
  },
}
</script>

<style lang="scss">
@import './wishlist-button';
</style>
